import { HTMLText } from 'pixi.js';
import type { HTMLTextStyle, TextString, TextStyleOptions } from 'pixi.js';
import type { LayoutTextSize } from './LayoutText';
import { LayoutText } from './LayoutText';

export class LayoutHTMLText extends HTMLText {
  private sizeRestrictions?: LayoutTextSize;

  set text(value: TextString) {
    super.text = value;
    LayoutText.processText(this);
    this.enforceSizeRestrictions();
  }

  get text(): string {
    return super.text;
  }

  set style(value: HTMLTextStyle | Partial<HTMLTextStyle> | TextStyleOptions) {
    super.style = value;
    this.enforceSizeRestrictions();
  }

  get style(): HTMLTextStyle {
    return super.style;
  }

  public setTextSizeRestrictions(sizeRestrictions: LayoutTextSize): void {
    this.sizeRestrictions = sizeRestrictions;
    this.enforceSizeRestrictions();
  }

  private enforceSizeRestrictions(): void {
    if (this.destroyed || !this.sizeRestrictions) return;
    const { maxWidth, maxHeight, maxFontSize } = this.sizeRestrictions;

    try {
      this.style.fontSize = maxFontSize;
      while (this.style.fontSize > 1 && ((maxWidth && this.width > maxWidth) || (maxHeight && this.height > maxHeight))) {
        this.style.fontSize -= 1;
      }
    } catch (e) {
      // Measuring text (Pixi CanvasTextMetrics) can throw when a webfont fails to decode
      // (e.g. a publisher-injected Roboto returning an invalid sfntVersion). Never let that
      // propagate out of layout population and freeze the game — skip auto-sizing this text.
      console.warn('LayoutHTMLText.enforceSizeRestrictions: text measurement failed', e);
    }
  }
}
